import React, { useEffect, useState } from "react";

interface TraxLogInfoReportProps {
    fleetInput: string;
    logPageNumberInput: string;
    itemNumberInput: string;
    disabled: boolean;   
    isNon737Tail:boolean; 
}

export const TraxLogInfoReport = ({fleetInput, logPageNumberInput, itemNumberInput, isNon737Tail, disabled}: TraxLogInfoReportProps) => {
    
    //Constants
    const reportBaseUrl = process.env.REACT_APP_REPORTSERVICE_URL;
    const haReportBaseUrl = process.env.REACT_APP_HA_REPORTSERVICE_URL || reportBaseUrl;

    //States
    const [fleet, setFleet] = useState(fleetInput);
    const [logPageNumber, setLogPageNumber] = useState(logPageNumberInput);
    const [itemNumber, setItemNumber] = useState(itemNumberInput);

    // Effects    
    // Fleet changed
    useEffect(() => {
        setFleet(fleetInput);
    }, [fleetInput]);

    // Log Page Number changed
    useEffect(() => {        
        setLogPageNumber(logPageNumberInput);    
    }, [logPageNumberInput]);

    // Item Number changed
    useEffect(() => {
        setItemNumber(itemNumberInput);
    }, [itemNumberInput]);

    // Event Handlers
    const openInNewTab = () => {
        const fleetCode = isNon737Tail ? "HA" : fleet === "1" ? "AS" : "VX";
        const effectiveReportBaseUrl = fleetCode === "HA" ? haReportBaseUrl : reportBaseUrl;
        const linops = fleetCode === "VX" ? "%20Linops" : "";
        const reportPath = `%2FAS%2FITSMandE%2FLine%20Maintenance%2F${fleetCode}%20DefectDetail%20Report${linops}`;
        const defectItemNumber = fleetCode === "HA" ? `&TraxDefectItemNumber=${encodeURIComponent(itemNumber)}` : "";
        const url = `${effectiveReportBaseUrl}/ReportServer/Pages/ReportViewer.aspx?${reportPath}&rs:Command=Render&TraxDefectNumber=${encodeURIComponent(logPageNumber)}${defectItemNumber}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    // Render
    return (
        <auro-popover removeSpace for="btnLogInfo">
            View Log Info
            <auro-button id="btnLogInfo"
            data-testid="btnLogInfo" 
                slim 
                secondary 
                slot="trigger" 
                disabled={disabled ? "disabled" : undefined}
                onClick={() => openInNewTab()}>            
                <auro-icon category="interface" name="external-link" customColor/>
            </auro-button>
        </auro-popover>
  );
};
